__turbopack_context__.v({
  "authorName": "AuthorBanner-module__dRp1qq__authorName",
  "card": "AuthorBanner-module__dRp1qq__card",
  "content": "AuthorBanner-module__dRp1qq__content",
  "contentHeader": "AuthorBanner-module__dRp1qq__contentHeader",
  "description": "AuthorBanner-module__dRp1qq__description",
  "link": "AuthorBanner-module__dRp1qq__link",
  "nameAndSocialLinks": "AuthorBanner-module__dRp1qq__nameAndSocialLinks",
  "picture": "AuthorBanner-module__dRp1qq__picture",
  "pictureWrapper": "AuthorBanner-module__dRp1qq__pictureWrapper",
  "socialMediaItem": "AuthorBanner-module__dRp1qq__socialMediaItem",
  "socialMediaList": "AuthorBanner-module__dRp1qq__socialMediaList",
});
